import React,{Component} from 'react';
import {withTranslation } from 'react-i18next';
import Dialog from '@react/react-spectrum/Dialog';
import SimplePDFViewer from './SimplePDFViewer';
import Loader from "../Common/Loader";
import NoRecords from "../Common/NoRecords";
import agreementService from "../../services/AgreementService";
import Close from "@react/react-spectrum/Icon/Close";
import Button from '@react/react-spectrum/Button';

export class CustomPDFDialog extends Component{
    constructor(props){
        super(props);
        this.state = {
            pdfError: null,
            loading: false,
            pdfUrl: null,
            isLoadingAPI: false
        };
        this.close = this.close.bind(this);
        this.cancel = this.cancel.bind(this);
        this.handlePDFError = this.handlePDFError.bind(this);
        this.fetchPDF = this.fetchPDF.bind(this);
        
        // Keep track of created object URLs for cleanup
        this.createdObjectURLs = [];
    }

    componentDidMount(){
        // Always fetch the PDF when modal opens, regardless of pdfUrl prop
        // This ensures we get fresh content every time
        this.fetchPDF();
    }

    componentDidUpdate(prevProps){
        if(prevProps.pdfUrl !== this.props.pdfUrl){
            if(this.props.pdfUrl && typeof this.props.pdfUrl === 'string' && this.props.pdfUrl.length > 0){
                this.setState({
                    pdfUrl: this.props.pdfUrl,
                    loading: false,
                    pdfError: null,
                    isLoadingAPI: false
                });
            } else {
                this.setState({
                    pdfUrl: null,
                    loading: false,
                    pdfError: null
                });
            }
        }
    }

    componentWillUnmount(){
        // Clean up object URLs to prevent memory leaks
        this.createdObjectURLs.forEach(url => {
            URL.revokeObjectURL(url);
        });
        this.createdObjectURLs = [];
    }

    close(){
        // Modal will close automatically when backdrop or X is clicked
    }

    cancel(){
        // Modal will close automatically when cancel is clicked
    }

    handlePDFError(error){
        console.error('PDF loading error in modal:', error);
        this.setState({ pdfError: error });
    }

    async fetchPDF(){
        if(!this.props.agreementId){
            this.setState({ 
                pdfError: 'No agreement ID provided',
                isLoadingAPI: false 
            });
            return;
        }

        this.setState({ 
            isLoadingAPI: true, 
            pdfError: null,
            pdfUrl: null
        });

        try {
            console.log('Fetching PDF for agreement ID:', this.props.agreementId);
            
            // Call the agreement service directly
            const response = await agreementService.viewAgreementPDF(this.props.agreementId,this.props.status, false);
            
            if (response && response.data) {
                // The response.data is a blob for PDF content
                const pdfBlob = response.data;
                
                // Create object URL from the blob
                const pdfUrl = URL.createObjectURL(pdfBlob);
                
                // Track the created URL for cleanup
                this.createdObjectURLs.push(pdfUrl);
                
                console.log('PDF fetched successfully, URL created:', pdfUrl);
                
                // Set the PDF URL in state
                this.setState({
                    pdfUrl: pdfUrl,
                    isLoadingAPI: false,
                    pdfError: null
                });
            } else {
                throw new Error('Invalid PDF response - no data received');
            }
        } catch (error) {
            console.error('Error fetching PDF:', error);
            this.setState({ 
                pdfError: error.message || 'Failed to load PDF',
                isLoadingAPI: false 
            });
        }
    }

    renderPDFContent(){
        const { pdfUrl, loading, pdfError, isLoadingAPI } = this.state;
        const isPDFValid = (pdfUrl && typeof pdfUrl === 'string' && pdfUrl.length > 0);

        // Show loading state when either internal loading or API loading
        if(loading || isLoadingAPI){
            return (
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    height: '100%',
                    minHeight: '300px'
                }}>
                    <Loader loaderSize="M"/>
                    <div style={{ 
                        marginTop: '16px', 
                        fontSize: '14px', 
                        color: '#666',
                        textAlign: 'center'
                    }}>
                        Loading PDF content...
                    </div>
                </div>
            );
        }

        if(pdfError){
            return (
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    height: '100%',
                    minHeight: '300px'
                }}>
                    <NoRecords message={pdfError || "pdfLoadError"} />
                </div>
            );
        }

        if(!isPDFValid){
            return (
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    height: '100%',
                    minHeight: '300px'
                }}>
                    <NoRecords message="noPDFFound" />
                </div>
            );
        }

        return (
            <div className="TableContainer" style={{ width: '100%', height: '100%', padding: 0 }}>
                <SimplePDFViewer 
                    pdfUrl={pdfUrl} 
                    onError={this.handlePDFError}
                />
            </div>
        );
    }

    render(){
        const { 
            agreementNumber,
            customerName
        } = this.props;

        const modalTitle = `Agreement PDF${agreementNumber ? ` - ${agreementNumber}` : ''}${customerName ? ` (${customerName})` : ''}`;

        return(
            <div data-am-id="pdfModal">
                <Dialog
                    role='dialog'
                    modalContent
                    mode="fullscreen"
                    onClose={this.close}
                    title={modalTitle}
                    confirmLabel={<Button variant="tool" icon={<Close />} aria-label="Close" onPress={this.cancel} />}
                    backdropClickable
                    size="L"
                    {...this.props}>
                    <div style={{ 
                        width: '100%', 
                        height: '110vh', 
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0'
                    }}>
                        {this.renderPDFContent()}
                    </div>
                    
                </Dialog>
            </div>
        )
    }
}

export default withTranslation()(CustomPDFDialog);
